import { ClipboardList, MessageSquare, BookOpen, Users, Check, Gem, GraduationCap, RefreshCw } from "lucide-react";
import { APPLICATIONS, WARTO_WIEDZIEC, CERTYFIKAT_NOTE, KORZYSCI, DLA_KOGO } from "../content";
import Reveal from "./Reveal";

const APP_ICONS = [ClipboardList, MessageSquare, BookOpen, Users];
const KORZYSCI_ICONS = [Gem, GraduationCap, RefreshCw];

export default function Applications() {
  return (
    <section id="o-kursie" className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <h2 className="text-2xl font-bold tracking-tight text-[#242344] sm:text-3xl lg:text-4xl">
            Co wykorzystasz na swoich lekcjach?
          </h2>
        </Reveal>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {APPLICATIONS.map((app, i) => {
            const Icon = APP_ICONS[i];
            return (
              <Reveal key={app.title} delay={i * 0.08}>
                <div
                  data-testid={`application-card-${i + 1}`}
                  className="h-full rounded-2xl border border-[#EAE6F0] bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:border-[#FFB3DA] hover:shadow-lg hover:shadow-[#FF008B]/5"
                >
                  <Icon size={28} className="text-[#FF008B]" aria-hidden="true" />
                  <h3 className="mt-4 text-lg font-bold leading-tight text-[#242344]">{app.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-[#34343F]">{app.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-2">
          <Reveal>
            <div className="h-full rounded-2xl bg-[#FDF4F8] p-7 sm:p-9">
              <h3 className="text-xl font-bold text-[#242344] sm:text-2xl">Co warto wiedzieć?</h3>
              <ul className="mt-5 space-y-2.5">
                {WARTO_WIEDZIEC.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-base text-[#34343F]">
                    <Check size={18} className="mt-0.5 shrink-0 text-[#FF008B]" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
              <p className="mt-5 border-t border-[#FFB3DA]/50 pt-5 text-base font-semibold leading-relaxed text-[#242344]">
                {CERTYFIKAT_NOTE}
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="h-full rounded-2xl border border-[#EAE6F0] bg-[#FAF8FC] p-7 sm:p-9">
              <h3 className="text-xl font-bold text-[#242344] sm:text-2xl">Korzyści z udziału:</h3>
              <ul className="mt-5 space-y-4">
                {KORZYSCI.map((item, i) => {
                  const Icon = KORZYSCI_ICONS[i];
                  return (
                    <li key={item} className="flex items-center gap-3.5 text-base text-[#34343F]">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-[#FF008B] shadow-sm">
                        <Icon size={19} aria-hidden="true" />
                      </span>
                      {item}
                    </li>
                  );
                })}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal>
          <h3 className="mt-16 text-xl font-bold text-[#242344] sm:text-2xl">
            Dla kogo jest ten kurs?
          </h3>
        </Reveal>
        <div className="mt-6 grid gap-4 sm:grid-cols-3">
          {DLA_KOGO.map((profile, i) => (
            <Reveal key={profile} delay={i * 0.08}>
              <div
                data-testid={`audience-card-${i + 1}`}
                className="h-full rounded-2xl border border-[#EAE6F0] bg-white p-6 text-base font-medium leading-relaxed text-[#34343F] transition-all duration-200 hover:-translate-y-1 hover:shadow-md"
              >
                <span className="mb-3 inline-block h-1.5 w-10 rounded-full bg-[#FF008B]" aria-hidden="true" />
                <p>{profile}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
